<template> 
  <div> 
    <div class="page-title flex-row me-3 mt-3"> 
        <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('profit_loss_operations') }}
        </h1>  
        <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
            <li class="breadcrumb-item text-gray-600">
                <a href="#" class="text-gray-600 text-hover-primary">
                    <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                </a>
            </li>  
            <li class="breadcrumb-item text-primary">{{ $t('accounting') }}</li> 
            <li class="breadcrumb-item text-primary">{{ $t('accounting_transaction') }}</li>
            <li class="breadcrumb-item text-gray-600">{{ $t('profit_loss_operations') }}
                <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
            </li>    
        </ul> 
    </div>  
    <div class="content flex-row-fluid mt-4" id="kt_content">  
        <div class="row"> 
            <div class="col-lg-12">
                <div class="card mb-6">
                    <div class="card-header border-0 pt-6">
                        <div class="card-title">
                        </div>
                        <div class="card-toolbar">
                            <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base" v-if="this.$isCredentialActive(55,'R')">
                                <Popper hover placement="top">
                                    <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                        <i class="bi bi-eraser-fill fs-4"> </i>
                                    </button>
                                    <template #content>
                                        <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                                    </template>
                                </Popper>
                                <button type="button" class="btn btn-light-primary border border-primary" @click="getData()" data-kt-indicator="on">
                                    <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                                    <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                                    <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                                    </svg>
                                    </span>
                                    <span v-if="!this.isListProgressing"> {{ $t('list_balances') }} </span> 
                                    <span class="indicator-progress" v-if="this.isListProgressing">
                                        {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span> 
                                </button>                        
                            </div>
                            <div class="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                                <div class="fw-bolder me-5">
                                <span class="me-2" data-kt-customer-table-select="selected_count"></span>{{ $t('selected') }}</div>
                                <button type="button" class="btn btn-danger" data-kt-customer-table-select="delete_selected">{{ $t('delete_selected') }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row p-3">
                            <form class="form fv-plugins-bootstrap5 fv-plugins-framework p-3 pb-0 pt-1 rounded-2 bg-light">
                                <div class="fv-row mb-7 row">    
                                    <div class="col-lg">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>{{ $t('accounting_period') }}</span> 
                                        </label>   
                                        <Select2 v-model="form.period_id" :options="accountingYears" :settings="{ width: '100%' }" @select="onChangeAccountYear($event)" :disabled="this.lists.length > 0"/>  
                                    </div> 
                                     <div class="col-lg">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>{{ $t('balance_type') }}</span>
                                        </label>
                                        <Select2 v-model="form.balance_type" :options="balanceTypeList" :settings="{width: '100%'}" :disabled="this.lists.length > 0"/>
                                    </div>
                                    <div class="col-lg">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>{{ $t('balance_date') }}</span>
                                        </label>
                                        <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.balance_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" @update:modelValue="onChangeBalanceDate()" :disabled="this.lists.length > 0"></Datepicker>
                                    </div>
                                    <div class="col-lg">
                                        <label class="fs-6 fw-bold form-label mt-3 required">
                                            {{ $t('transaction_type') }}
                                        </label>
                                        <Select2 v-model="form.transaction_type" :options="transactionTypeList" @select="onChangeTransactionType()" :settings="{width: '100%'}" :disabled="this.lists.length > 0"/>
                                    </div> 
                                      <div class="col-lg">
                                        <!-- Accounting plansdaki Income vs seçili olan hesaplar gelecek -->
                                        <label class="fs-6 fw-bold form-label mt-3 required">
                                            <span v-if="form.transaction_type == -1"> {{ $t('account_plan') }}</span> 
                                            <span v-if="form.transaction_type == 1"> {{ $t('income_close_plan') }}</span> 
                                            <span v-if="form.transaction_type == 2"> {{ $t('expense_close_plan') }}</span> 
                                            <span v-if="form.transaction_type == 3"> {{ $t('cost_close_plan') }}</span> 
                                            <span v-if="form.transaction_type == 4"> {{ $t('other_income_close_plan') }}</span>
                                            <span v-if="form.transaction_type == 5"> {{ $t('other_expense_close_plan') }}</span>
                                            <span v-if="form.transaction_type == 0"> {{ $t('all_plans') }}</span>
                                        </label>
                                        <Select2 v-model="form.target_account_id" :options="targetAccountsList" :settings="{width: '100%'}" :disabled="this.lists.length > 0"/>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                            <div>
                                <!-- Tercih edilen Balance Type'a göre hesap bakiyeleri gelecek -->
                                <!-- Comparative Balance General görüntüsü gelecek . Level 1'ler olmayacak. Background renkleri aynı olack (Accounting Transaction gibi) --> 
                                <!-- Kayıt Kuralı: Balance = 0 olacak -->

                                <!-- Opening için geçerli -->
                                <!-- Kapanıştan alıyorsa -> Önceki dönemde kapatılan kayıtları bul, onları aç. Hep ters kayıt yapılır. Balance debit ise, credit kaydı yapılacak. Sıfırlanması için -->
                                <!-- Accounting Balances -> gördüğü bakiyenin aynısını kaydedecek. Paralel kayıt  -->

                                <!-- Closing -->
                                <!-- Her zaman ters kayıt yapılır -->

                                <!-- Önceki dönemdeki muhasebe planı bu dönemde yoksa kırmızı ile işaretlenecek ve editlenebilecek (Yeni plan kodunu seçeceğiz listeden) -->
                            
                                <DxDataGrid id="gridContainer" :key="$i18n.locale"  
                                        :show-borders="true" 
                                        :data-source="lists" 
                                        :allow-column-reordering="true"  
                                        :allow-column-resizing="true" 
                                        :column-auto-width="true" 
                                        :row-alternatin-enabled="true"
                                        :hover-state-enabled="true" 
                                        :show-row-lines="true" 
                                        @exporting="this.$onExporting($event , 'Profit-And-Loss-Operations')"> 

                                        <DxFilterRow :visible="true"/>
                                        <DxHeaderFilter :visible="true"/>
                                        <DxGroupPanel :visible="true"/>      
                                        <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                        <DxPaging :page-size="100"/>
                                        <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/>
                                        <DxSearchPanel :visible="false"/>  
                                        <DxScrolling
                                            mode="virtual"
                                            row-rendering-mode="virtual"
                                        />
                                        <DxColumn data-field="l2_account_code" :caption="$t('account_code')" header-cell-template="lt-account-code-header" />
                                        <DxColumn data-field="l2_account_name" :caption="$t('account_name')" header-cell-template="lt-account-name-header" />
                                        <DxColumn data-field="account_code" :caption="$t('account_code')" header-cell-template="account-code-header" />
                                        <DxColumn data-field="account_name" :caption="$t('account_name')" header-cell-template="account-name-header" />
                                        <DxColumn data-field="balance" :sorting-method="this.$numericSort" :caption="$t('balance')" alignment="right" />
                                        <DxColumn data-field="debit_credit" :caption="$t('debit_credit')" header-cell-template="debit-credit-header"/>

                                        <template #lt-account-code-header>
                                            <div>{{ $t('account_code_level_2') }}</div>
                                        </template>
                                        <template #lt-account-name-header>
                                            <div>{{ $t('account_name_level_2') }}</div>
                                        </template>
                                        <template #account-code-header>
                                            <div>{{ $t('account_code') }}</div>
                                        </template>
                                        <template #account-name-header>
                                            <div>{{ $t('account_name') }}</div>
                                        </template>
                                        <template #new-account-code-header>
                                            <div>{{ $t('new_account_code') }}</div>
                                        </template>
                                        <template #debit-credit-header>
                                            <div>{{ $t('debit_credit') }}</div>
                                        </template>

                                        <!-- Cell Templates --> 
                                        <!-- <template #lt-account-code-cell-template="{ data }">
                                             {{ data.data.l2_account_code }}
                                        </template> 
                                        <template #lt-account-name-cell-template="{ data }">
                                            {{ data.data.l2_account_name }}
                                        </template> 
                                        <template #account_code-cell-template="{ data }">
                                             {{ data.data.account_code }}
                                        </template> 
                                        <template #account_name-cell-template="{ data }">
                                             {{ data.data.account_name }}
                                        </template> 
                                        <template #balance-cell-template="{ data }">
                                             {{ data.data.balance }}
                                        </template> 
                                        <template #debit_credit-cell-template="{ data }">
                                            {{ data.data.debit_credit }}
                                        </template>  -->

                                        <DxSummary :calculate-custom-summary="setSummaries">
                                            <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="l2_account_code"/>
                                                <DxGroupItem
                                                :show-in-group-footer="true"
                                                name="balance"
                                                summary-type="custom"
                                                show-in-column="balance"
                                                display-format="{0}"
                                                /> 
                                                <DxTotalItem
                                                    name="balance"
                                                    summary-type="custom"
                                                    show-in-column="balance"
                                                />
                                        </DxSummary>
                                </DxDataGrid>
                            </div>
                        </div> 
                    </div>
                </div> 
            </div>
            <div class="col-lg-12">
                <div class="card card-xxl-stretch mb-6">
                    <div class="card-body">
                        <div class="col-lg-12">
                            <form class="form fv-plugins-bootstrap5 fv-plugins-framework p-3 pb-0 pt-1 rounded-2">
                                <div class="fv-row mb-7 row">
                                    <div class="col-lg-2">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>{{ $t('voucher_date') }}</span>
                                            <!-- Accounting Periyodun son günü setlenecek bu alana -->
                                        </label>
                                        <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.record_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"></Datepicker>
                                        <!-- :minDate="this.form.periodSelection.start_date" :maxDate="this.form.periodSelection.end_date" -->
                                    </div>
                                    <div class="col-lg-10">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>{{ $t('description') }}</span>
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" name="discount" v-model="form.description">
                                            <div class="input-group-append" v-if="this.descriptionTypeList.length > 0">
                                                <div class="dropdown dropup">
                                                    <button class="btn btn-secondary border border-gray-300 dropdown-toggle rounded-start-0" type="button" @click="this.isOpenDescriptionDropdown = !this.isOpenDescriptionDropdown;">
                                                        <i class="bi bi-plus-lg fs-5 fw-boldest"> </i>
                                                    </button>
                                                    <div class="dropdown-menu px-3 dropdown-menu-end" data-bs-popper="true" :class="{ 'show': this.isOpenDescriptionDropdown }">
                                                        <ul class="mh-250px mb-0 overflow-scroll list-unstyled"> 
                                                            <li v-for="(item, index) in descriptionTypeList" v-bind:key="item">
                                                                <a class="dropdown-item cursor-pointer p-2 mw-500px" @click="onSelectDescription(item)"
                                                                    :class="{'text-success': this.form.description == item.description && item.description !== ''}">
                                                                    <i class="bi bi-dash fw-boldest" v-if="this.form.description !== item.description"> </i> 
                                                                    <i class="bi bi-check-lg fw-boldest text-success" v-if="this.form.description == item.description && item.description !== ''"> </i>
                                                                    {{item.text}}  
                                                                </a>
                                                                <div class="separator separator-dashed my-1" v-if="index !== descriptionTypeList.length - 1"></div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12" v-if="this.$isCredentialActive(55,'I')">
                <div class="card card-xxl-stretch mb-6">
                    <div class="card-body">
                        <div class="d-grid gap-2"> 
                            <button class="btn btn-success btn-lg" type="button" @click="saveProfitAndLossVoucher()" data-kt-indicator="on" :disabled="!this.lists.length > 0"> 
                                <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                </svg>
                                </span>  
                                <!-- Kayıttan sonra ekranı temizleyip mesaj verip alanları sıfırlayacağız. (İşlem tamamlandı)-->
                                <!-- Bulduğu kayıtlara ters kayıt yapacak. Debit ise Credit -- > Credit ise Debit olacak -->
                                <strong v-if="!this.isSaving"> {{ $t('create_profit_loss_voucher') }} </strong> 
                                <span class="indicator-progress" v-if="this.isSaving">
                                    {{ $t('saving-transaction-please-wait') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>  
  </div>  
</template>

<script>
import axios from 'axios' 
import moment from 'moment';

import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxColumn,DxGroupItem, DxSearchPanel, DxTotalItem, DxSummary, DxScrolling } from 'devextreme-vue/data-grid';
 
export default {
    name: "ProfitAndLossOperationsList",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxColumn,DxGroupItem, DxSearchPanel, DxTotalItem, DxSummary, DxScrolling
    },
	data() {
        return {
            searchbar: '',
            isOpenDescriptionDropdown: false,
            isListProgressing: false,
            isOpenActionsDropdown: false,      
            page: 1,
            page_size: 10,
            pageSize: 100,
            summary: {},
            lists: [],
            accountingYearList: [],
            accountingYearSelection: null,
            accountingYears: [],
            form:  {
                balance_date: moment(), 
                record_date: moment(),
                period_id: null,
                periodSelection: {},
                transaction_type: -1,
                balance_type: 1,
                target_account_id: '-1'
            },
            targetAccountsList: [{ id: '-1', text: this.$t('select_an_option')}],
            balanceTypeList: [
                { id: 1, text: this.$t('accounting_balances')}
            ],
            transactionTypeList: [
                { id: -1, text: this.$t('select_an_option')},
                { id: 1, text: this.$t('income_closing')},
                { id: 2, text: this.$t('expense_closing')},
                { id: 3, text: this.$t('cost_closing')},
                { id: 4, text: this.$t('other_income_closing')},
                { id: 5, text: this.$t('other_expense_closing')},
                { id: 0, text: this.$t('all')},
            ],
            isAccountingYearLoading: false,
            descriptionTypeList: [],
            menuSelection : '/ProfitOperationsHelppage',
            iconView : false,
            isSaving: false

        };
  },
  computed: {  
    searchableList() {
      return this.lists.slice((this.page - 1) * this.page_size, this.page * this.page_size);
    },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    previewOnlyDate(){
        return (value)=>{
        if (value) {
            return moment(new Date(value)).format('DD.MM.YYYY')
            }
        }
    },
    getReportTypeValue(){
        return (value)=>{
            if (value) {
                return this.reportTypes.find(p => { 
                    return p.id == value;
                }).text; 
            }
        } 
    },
    getPeriodMonthValue(){
            return (value)=>{
            if (value) {
                var period = this.periodList.find(p => { 
                    return p.id == value && p.id != '-1';
                }); 
                if(period){
                    return period.text;
                }
                else{
                    return null;
                }
            }
        } 
    },
    showPageSizeSelector() {
        return this.lists.length > this.pageSize;
    },
    pageSizes() {
        let arr = [];
        let x = 1;
        let loop = (this.lists.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    }
  },
  methods: { 
    getData() {
        if(this.form.target_account_id == '-1' || this.form.transaction_type == '-1'){
            this.$swal(this.$t('required_fields'), this.$t('transaction_type_and_account_plan_selection_is_required'), 'warning');  
            return;
        }
        this.lists = []; 
        const params = {
            session_id: this.$getUser().session_id,
            balance_date: moment(this.form.balance_date).format('YYYY-MM-DD[T]HH:mm:ss'),
            period_id: this.form.period_id,
            transaction_type: this.form.transaction_type
        };
        axios.post('/api/ProfitAndLoss/GetList', params, {'Content-Type': 'application/json'})
        .then((response) => {  
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                this.lists = response.data.data; 
            }
            else{
                this.lists = [];
            }
            this.$Progress.finish();
        })
        .catch((error) => {
            console.error(error); 
            this.$Progress.fail();
        });
    },
    getAccountingYears(){
        this.isAccountingYearLoading = true;
        this.companyAccountingPeriods = [];
        const queryParameter = {
            session_id: this.$getUser().session_id
        };
        axios.post('/api/Auth/GetCompanyAccountingYears', queryParameter, {'Content-Type': 'application/json'})
        .then((response) => {   
                this.accountingYears = response.data; 
                this.accountingYears.forEach((period) => {
                    if(period.id == this.$getSessionStorage('activeYear')){
                        this.form.period_id = period.id;
                        this.form['periodSelection'] = period; 
                        this.form.record_date = moment(this.form['periodSelection'].end_date); 
                        this.form.balance_date = moment(this.form['periodSelection'].end_date); 
                    } 
                }); 
                this.getDescriptions();
                
                // Seçili olan Period eğer 'Aktif' mali dönem ise Record Date bugüne setlenir.
                // Değilse; seçim yapılan Mali dönemin bitiş tarihine setlenir.
                // if((moment().isBetween(moment(this.form['periodSelection'].start_date), moment(this.form['periodSelection'].end_date))) == false){
                //     this.form.start_date = this.form['periodSelection'].start_date;
                //     this.form.end_date = this.form['periodSelection'].end_date;
                // }
                setTimeout(() => {
                    this.isAccountingYearLoading = false;
                }, 1000); 
        })
        .catch((error) => {
            this.isAccountingYearLoading = false;
            console.error(error);
        }); 
    },  
    onChangeTransactionType() {
        this.form.target_account_id = '-1';
        if (this.form.transaction_type == -1) {
            this.targetAccountsList = [{ id: '-1', text: this.$t('select_an_option')}]; 
            this.getDescriptions();
            return;
        }
        const queryParameter = {
            session_id: this.$getUser().session_id,
            accounting_period_id: this.form.period_id,
            list_type: 17,
            list_account_type: this.form.transaction_type
        };  
        axios.post('/api/Helper/GetAccountingPlanByParameter', queryParameter, {'Content-Type': 'application/json'}) 
        .then((response) => {
            this.targetAccountsList = response.data;
            this.targetAccountsList.forEach((item) => {
                item.text = item.final_code + ' - ' + item.name;
            });
            this.targetAccountsList.unshift({id: '-1', name: this.$t('select_an_option'), text: this.$t('select_an_option')});
            this.getDescriptions();
        });

    },
    onChangeAccountYear(e){
        this.form['periodSelection'] = e;
        this.form.record_date = this.form['periodSelection'].end_date; 
        this.form.balance_date = this.form['periodSelection'].end_date; 
    },
    setCriteriasToDefault() {   
        this.form = {
            balance_date: moment(), 
            period_id: null,
            periodSelection: {},
            transaction_type: -1,
            balance_type: 1,
            target_account_id: '-1',
            record_date: moment(),
        };
        this.form.record_date = moment(this.form['periodSelection'].end_date); 
        this.form.balance_date = moment(this.form['periodSelection'].end_date); 
        this.lists = [];
        this.getAccountingYears();
    },
    getDescriptions() {
        this.isOpenDescriptionDropdown = false;
        const params = {
            session_id: this.$getUser().session_id,
            description_location: 16, // Profit & Loss Operations
            location_detail: this.form.transaction_type,
            account_type: 0,
            sales_type: 0
        };
        axios.post('/api/Helper/GetDescriptionTypes', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            this.descriptionTypeList = response.data;
            this.descriptionTypeList.forEach(element => {
                if (element.type_id == 2) {
                    this.form.description = element.description;
                }
            });
            this.$Progress.finish();
        })
        .catch((error) => {
            console.error(error); 
            this.$Progress.fail();
        });
    },
    onSelectDescription(item) {
        this.form.description = item.description;
        this.isOpenDescriptionDropdown = false;
    },
    saveProfitAndLossVoucher(){ 
        this.$swal.fire({
            title: this.$t('you_are_about_to_save_2'),
            confirmButtonColor: "#50cd89",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('confirm'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {  
                this.isSaving = true;
                const params = {
                    session_id: this.$getUser().session_id,
                    balance_date: moment(this.form.balance_date).format('YYYY-MM-DD[T]HH:mm:ss'),
                    period_id: this.form.period_id,
                    transaction_type: this.form.transaction_type,
                    description: this.form.description,
                    record_date: moment(this.form.record_date).format('YYYY-MM-DD[T]HH:mm:ss'),
                    target_account_id: this.form.target_account_id
                };
                const that = this;
                axios.post('/api/ProfitAndLoss/Create', params, {'Content-Type': 'application/json'})
                .then((response) => { 
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                        this.$swal(this.$t('success'), this.$t('closing_voucher_saved_successfully'), 'success');  
                        this.setCriteriasToDefault();
                    }
                    that.isSaving = false;
                    this.$Progress.finish();
                })
                .catch((error) => {
                    that.isSaving = false;
                    console.error(error); 
                    this.$Progress.fail();
                });
            }
        }); 
    }, 
    onChangeBalanceDate(){
        this.form.record_date = moment(this.form.balance_date);
    },
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/ProfitOperationsHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    },
    setSummaries(options){  
        if(options.name == "balance"){
            if(options.summaryProcess === 'start'){
                options.totalValue = 0;
            }
            else if(options.summaryProcess === 'calculate'){
                var balance = parseFloat(options.value.balance.replaceAll(',', ''));
                (options.totalValue += balance);
            }
            else if(options.summaryProcess === 'finalize'){ 
                options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
            }
        }   
    } 
  },
  created() {    
    this.helpPageViewIcon();    
    this.getAccountingYears();
    this.$removeSessionStorage('record_id');
  },
  mounted(){ 
    try{ 
        this.form.start_date = moment().subtract((parseInt(this.$getUser().list_date_range)), 'days');
    }
    catch(Err){ console.error(Err);}
  }
}; 
</script>